// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ADmOm","header":"ReportDetails_header__1ep5v","title":"ReportDetails_title__3HbDL","left":"ReportDetails_left__1BRmS"};